var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type, Transform } from 'class-transformer';
import { IsString, IsUUID, IsNotEmpty, ValidateNested, } from 'class-validator';
export class ChatSupportCredentialsFields {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ChatSupportCredentialsFields.prototype, "id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ChatSupportCredentialsFields.prototype, "display_name", void 0);
export class ChatSupportCredentials {
}
__decorate([
    ValidateNested(),
    Type(() => ChatSupportCredentialsFields),
    IsNotEmpty(),
    __metadata("design:type", ChatSupportCredentialsFields)
], ChatSupportCredentials.prototype, "fields", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ChatSupportCredentials.prototype, "hash", void 0);
